import { NoSpacesString } from '@/types';
import { ReactNode } from 'react';
import clsx from 'clsx';

interface Props<T extends string> {
  className?: string;
  children?: ReactNode;
  childrenClassName?: string;
  dataCy?: NoSpacesString<T>;
  id?: string;
}

const Container = <T extends string>({
  className,
  children,
  id,
  childrenClassName = 'px-1 md:px-2 lg:px-4',
  dataCy = 'container' as NoSpacesString<T>,
}: Props<T>) => {
  if (!children) {
    return null;
  }
  return (
    <div className={className} data-cy={dataCy} {...(id && { id })}>
      <div className={clsx('container mx-auto min-h-[inherit]', childrenClassName)}>{children}</div>
    </div>
  );
};

export default Container;
